import { Geist, Geist_Mono } from "next/font/google";
import { StorefrontChrome } from "@/components/storefront-chrome";
import { Snipcart } from "@/components/snipcart";
import type {
  StorefrontLayoutVariant,
  StorefrontShellData,
} from "@/lib/storefront-shell-types";
import {
  buildStorefrontThemeVariables,
  getStorefrontSiteConfig,
  type StorefrontSiteCode,
} from "@/lib/storefront-site";
import type { NavigationItem } from "@/lib/storefront-types";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

type StorefrontShellProps = {
  navigationItems: NavigationItem[];
  shellData?: StorefrontShellData;
  layoutVariant?: StorefrontLayoutVariant;
  siteCode?: StorefrontSiteCode;
  children: React.ReactNode;
};

export function StorefrontShell({
  navigationItems,
  shellData,
  layoutVariant,
  siteCode,
  children,
}: StorefrontShellProps) {
  const site = getStorefrontSiteConfig(siteCode);

  return (
    <div
      data-storefront-site={site.code}
      style={buildStorefrontThemeVariables(site.code)}
      className={`${geistSans.variable} ${geistMono.variable} storefront-shell-background min-h-screen text-white antialiased`}
    >
      <Snipcart site={site} />
      <StorefrontChrome
        navigationItems={navigationItems}
        shellData={shellData}
        layoutVariant={layoutVariant}
        site={site}
      >
        {children}
      </StorefrontChrome>
    </div>
  );
}
